import React, { useState } from "react";

export default function SharedMediaGrid({ items = [], isProbablyGifUrl }) {
  const [preview, setPreview] = useState(null);

  if (!items.length) {
    return (
      <p className="text-[13px] text-white/45 py-6 text-center rounded-xl border border-white/10 bg-white/[0.02]">
        No photos or GIFs shared yet
      </p>
    );
  }

  return (
    <>
      <div className="grid grid-cols-3 gap-2 max-h-[280px] overflow-y-auto fc-scroll pr-1">
        {items.map((row) => {
          const url = String(row.url || row.message || "").trim();
          const isGif = isProbablyGifUrl?.(url);
          return (
            <button
              key={row.id}
              type="button"
              onClick={() => setPreview(url)}
              className="relative aspect-square overflow-hidden rounded-xl border border-white/12 bg-black/30 hover:border-white/25 transition"
            >
              {isGif ? (
                <img src={url} alt="" className="h-full w-full object-cover" loading="lazy" />
              ) : (
                <img src={url} alt="" className="h-full w-full object-cover" loading="lazy" />
              )}
            </button>
          );
        })}
      </div>

      {preview && (
        <div
          role="presentation"
          className="fixed inset-0 z-[80] flex items-center justify-center bg-black/80 p-4 backdrop-blur-sm"
          onClick={() => setPreview(null)}
        >
          <button
            type="button"
            className="absolute top-6 right-6 h-10 w-10 rounded-full border border-white/20 bg-white/10 text-white text-lg leading-none hover:bg-white/20"
            onClick={(e) => {
              e.stopPropagation();
              setPreview(null);
            }}
            aria-label="Close preview"
          >
            ×
          </button>
          <img
            src={preview}
            alt="Preview"
            className="max-h-[85vh] max-w-[min(960px,95vw)] rounded-2xl object-contain shadow-2xl border border-white/10"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </>
  );
}
